<template>
	<div class="spinner">
		<div class="spinner-content">
			<div class="loader-circle"></div>
			<div class="loader-line-mask">
				<div class="loader-line"></div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'LoadingSpinner',
}
</script>



// WEBPACK FOOTER //
// src/utils/commons/LoadingSpinner.vue